// @ts-nocheck
/* eslint-disable */

export const headIsScriptError = () => {
  window.onerror = function(message, source, noligne, nocolonne, error) {
    var isScriptError = message.toLowerCase().indexOf('script error') > -1;
    if (window.Rollbar && !isScriptError) window.Rollbar.error(message, error);
  };
};
